import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import RateOfChange from '../RateOfChange';

const SilverChange = () => {

    const [title ,setTitle] = useState('silver_ticker')
    const [defaultVal ,setDefaultVal] = useState('Silver')
    useEffect(() => {
        if(window.location.hostname.includes("silverprice.org")) {
            setTitle("gold_ticker")
            setDefaultVal("Gold")
            localStorage.setItem("s_ticker_title", "gold_ticker")
            localStorage.setItem("s_ticker_val", "Gold");
        }
    }, [])
    const ticker_title = localStorage.getItem("s_ticker_title") ? localStorage.getItem("s_ticker_title") : title   
    const ticker_defaultval = localStorage.getItem("s_ticker_val") ? localStorage.getItem("s_ticker_val") : defaultVal   
    return (
        <div className="gold-change">
            <RateOfChange title = {ticker_title} default = {ticker_defaultval} />
        </div>
    )
}

export default SilverChange;